import React from 'react'

export function UserMissionSkeleton() {
  return (
    <div className='w-[375px] h-[333px] mobile:w-full tablet:h-auto border border-gray-4 rounded-lg shadow p-[20px]'>
      <div className='animate-pulse flex flex-col justify-center items-center space-[12px] h-full'>
        <div className='h-3 bg-gray rounded w-[100px]' />
        <div className='w-[100px] h-[100px] rounded-full bg-gray' />
        <div className='h-2 bg-gray rounded w-[100px]' />
        <div className='h-2 bg-gray rounded w-[90%]' />
        <div className='flex space-x-5 tablet:space-x-2'>
          <div className='w-[28px] h-[28px] rounded-full bg-gray' />
          <div className='w-[28px] h-[28px] rounded-full bg-gray' />
          <div className='w-[28px] h-[28px] rounded-full bg-gray' />
          <div className='w-[28px] h-[28px] rounded-full bg-gray' />
          <div className='w-[28px] h-[28px] rounded-full bg-gray' />
        </div>
        <div className='h-2 bg-gray rounded w-[140px]' />
        <div className='h-2 bg-gray rounded w-[190px]' />
        <div className='h-2 bg-gray rounded w-[150px]' />
      </div>
    </div>
  )
}
